import { FileEdit } from 'lucide-react'

interface PlanCardProps {
  data: Record<string, unknown>
}

function parseOutlineItems(outline: unknown): string[] {
  if (Array.isArray(outline)) {
    return outline
      .map((item) => {
        if (typeof item === 'string') return item
        if (item && typeof item === 'object') {
          const o = item as Record<string, unknown>
          return String(o.title ?? o.heading ?? o.section ?? o.name ?? JSON.stringify(item))
        }
        return String(item)
      })
      .filter(Boolean)
  }
  if (typeof outline === 'string') {
    return outline
      .split('\n')
      .map((l) => l.replace(/^[\s#\-*\d.]+/, '').trim())
      .filter(Boolean)
  }
  return []
}

export function PlanCard({ data }: PlanCardProps) {
  const items = parseOutlineItems(data.outline)

  return (
    <div className="rounded-xl border border-slate-100 bg-white shadow-sm p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className="flex items-center justify-center w-7 h-7 rounded-lg bg-violet-50 text-violet-600">
          <FileEdit className="w-3.5 h-3.5" />
        </div>
        <span className="text-xs font-semibold text-slate-600 uppercase tracking-wide">
          Estructura
        </span>
      </div>

      {items.length > 0 ? (
        <ol className="space-y-1.5">
          {items.map((section, i) => (
            <li key={i} className="flex items-start gap-2 min-w-0">
              <span className="text-xs font-semibold text-violet-400 shrink-0 mt-0.5 w-4 text-right">
                {i + 1}.
              </span>
              <span className="text-xs text-slate-600 leading-relaxed">{section}</span>
            </li>
          ))}
        </ol>
      ) : (
        <p className="text-xs text-slate-400">Estructura generada</p>
      )}
    </div>
  )
}
